import React, { useState, useCallback } from 'react';
import cn from 'classnames';

import StickyMenuOnTabsItem from './StickyMenuOnTabsItem';
import Link from 'components/link/Link';

import { IStickyMenuOnTabs } from 'source/NFR.types';

interface StickyMenuOnTabsProps extends IStickyMenuOnTabs {
  className?: string;
}

const StickyMenuOnTabs: React.FC<StickyMenuOnTabsProps> = ({ navGroups = [], title, className }) => {
  const [enableScroll, setEnableScroll] = useState(false);

  const setScroll = useCallback((menu: HTMLDivElement | null) => {
    if (menu) {
      const shouldScroll = window.innerHeight < menu.offsetHeight + 50;
      setEnableScroll(prev => (shouldScroll !== prev ? shouldScroll : prev));
    }
  }, []);

  return (
    <div className={cn('sticky-menu-on-tabs', className)}>
      <div
        className="sticky-menu-on-tabs--content"
        ref={setScroll}
        style={{ overflowY: enableScroll ? 'scroll' : 'hidden' }}
      >
        {title && <h3 className="sticky-menu-on-tabs--title">{title}</h3>}
        {navGroups.length > 0 && (
          <nav>
            {navGroups?.map(({ titleLink, links }, index) => (
              <React.Fragment key={`${titleLink?.text}-${index}`}>
                {titleLink?.text && (
                  <Link className="sticky-menu-on-tabs--title-link" theme="actionLink" {...titleLink} />
                )}
                {links && links.items && !!links.items.length && (
                  <ul>
                    {links.items?.map(
                      item => item && item.link && <StickyMenuOnTabsItem key={item.link.url} {...item} />
                    )}
                  </ul>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
      </div>
    </div>
  );
};

StickyMenuOnTabs.displayName = 'StickyMenuOnTabs';

export default StickyMenuOnTabs;
